"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "WidgetLoadingContent", {
    enumerable: true,
    get: function() {
        return WidgetLoadingContent;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const WidgetLoadingContent = (param)=>{
    let { height, width, disableAnimation } = param;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "21c91f52fc602946",
                [
                    height,
                    width != null ? "".concat(width, "px") : "100%",
                    disableAnimation === true ? "0s" : "2s"
                ]
            ]
        ]) + " " + "skeleton"
    }), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "21c91f52fc602946",
        dynamic: [
            height,
            width != null ? "".concat(width, "px") : "100%",
            disableAnimation === true ? "0s" : "2s"
        ]
    }, ".skeleton.__jsx-style-dynamic-selector{height:".concat(height, "px;width:").concat(width != null ? "".concat(width, "px") : "100%", ";-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;-webkit-box-ordinal-group:1;-webkit-order:0;-moz-box-ordinal-group:1;-ms-flex-order:0;order:0;-webkit-box-flex:0;-webkit-flex-grow:0;-moz-box-flex:0;-ms-flex-positive:0;flex-grow:0;position:relative;background-color:#f5f5f5;overflow:hidden}.skeleton.__jsx-style-dynamic-selector:after{position:absolute;top:0;right:0;bottom:0;left:0;-webkit-transform:translatex(-100%);-moz-transform:translatex(-100%);-ms-transform:translatex(-100%);-o-transform:translatex(-100%);transform:translatex(-100%);background:-webkit-linear-gradient(left,#f5f5f5 0%,#efefef 15%,#f5f5f5 30%);background:-moz-linear-gradient(left,#f5f5f5 0%,#efefef 15%,#f5f5f5 30%);background:-o-linear-gradient(left,#f5f5f5 0%,#efefef 15%,#f5f5f5 30%);background:linear-gradient(to right,#f5f5f5 0%,#efefef 15%,#f5f5f5 30%);-webkit-animation:shimmer ").concat(disableAnimation === true ? "0s" : "2s", " infinite;-moz-animation:shimmer ").concat(disableAnimation === true ? "0s" : "2s", " infinite;-o-animation:shimmer ").concat(disableAnimation === true ? "0s" : "2s", " infinite;animation:shimmer ").concat(disableAnimation === true ? "0s" : "2s", ' infinite;content:""}@-webkit-keyframes shimmer{100%{-webkit-transform:translatex(100%);transform:translatex(100%)}}@-moz-keyframes shimmer{100%{-moz-transform:translatex(100%);transform:translatex(100%)}}@-o-keyframes shimmer{100%{-o-transform:translatex(100%);transform:translatex(100%)}}@keyframes shimmer{100%{-webkit-transform:translatex(100%);-moz-transform:translatex(100%);-o-transform:translatex(100%);transform:translatex(100%)}}')));
};

//# sourceMappingURL=WidgetLoadingContent.js.map